


























































import { mapGetters } from 'vuex'
import Vue from 'vue'
import Button from '@/types/components/Button.interface'
import tenantNavMixin from '@/mixins/tenant-nav-mixin'
import { signoutConfirm } from '@/utility/helpers'
import UserLogo from '@/components/UserLogo.vue'
export default Vue.extend({
    mixins: [tenantNavMixin],
    components: { UserLogo },
    computed: {
        ...mapGetters(['isAdminOfAny', 'isMobile', 'tenant', 'user']),
        accountMenu(): boolean {
            //  If a tenant exists, we return all the links
            if (this.tenant) {
                return this.links.filter((link: Button) =>
                    this.$store.getters.userHasPermission(link.permission)
                )
            }
            //  Else, we only return links with permission 0 (ie no tenant scope)
            return this.links.filter((link: Button) => link.permission === 0)
        },
        links(): Button[] {
            return [
                {
                    text: 'Account Settings',
                    icon: 'mdi-cog',
                    color: 'grey',
                    callback: () => this.goToAccount(),
                    permission: 1
                },
                {
                    text: 'Team',
                    icon: 'mdi-contacts',
                    color: 'grey',
                    callback: () => this.goToUsers(),
                    permission: 2
                },
                {
                    text: 'Add Profile Image',
                    icon: 'bi-person-bounding-box',
                    color: 'grey',
                    callback: () => this.goToUserImage(),
                    permission: 1,
                    hidden: this.user.logo_route
                },
                // {
                //     text: 'Refer Friends, Get Rewards',
                //     icon: 'bi-cash',
                //     color: 'grey',
                //     callback: () => this.$router.push('/referral'),
                //     permission: 1
                // },
                {
                    text: 'Signout',
                    icon: 'mdi-shield-lock-outline',
                    callback: () => signoutConfirm(),
                    permission: 0
                }
            ]
        },
        listHeight(): number {
            //  Find out how many links will be rendered
            const length = this.accountMenu.length || 0
            //  Sum is length * 96
            const sum = length * 96
            //  Subtract it from content height
            return 600 - sum
        },
        reseller(): boolean {
            //  Check if the user is a reseller
            const isReseller = this.user.reseller && this.isAdminOfAny
            //  Check if we're already on the memberhsips page
            const blocked = this.$route.path.includes('/memberships')
            return isReseller && !blocked
        }
    },
    methods: {
        goToSelf(): void {
            this.$router.push(`/teammates?user=${this.user.id}&logo=true`)
        },
        goToAccount(): void {
            this.$router.push(`/account`)
        },
        goToUsers(): void {
            this.$router.push(`/teammates`)
        },
        goToUserImage(): void {
            this.$router.push(`/teammates?user=${this.user.id}&logo=true&personprof=true`)
        },
        goToWorkspaces(): void {
            //  To prevent cross pollination, ALWAYS reset tenant when nav to memberships
            this.$store.commit('tenantSet', null)
            this.$router.push('/memberships')
        },
        openIssueForm(): Window {
            const tenant_id = this.tenant ? this.tenant.id : '???'

            const user_id = this.user ? this.user.id : '???'

            return window.open(
                `https://messagedesk.typeform.com/to/f6LIfBOk?tenant_id=${tenant_id}&user_id=${user_id}`
            )
        },
        suggestFeatureLink(): Window {
            return window.open('https://messagedesk.nolt.io/roadmap', '_blank')
        }
    }
})
